import { styled } from '@material-ui/core/styles';

export const Container = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(3)
}));

export const LoaderContainer = styled('div')({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center'
});
